import React from "react";

const Objectives = () => {
  return (
    <section className="bg-[#fafad5] text-black">
      <div className="mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-lg text-center">
          <h2 className="text-3xl font-bold sm:text-4xl">Objectives</h2>
        </div>

        {/* Objectives */}

        <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <p
            className="textDecoration-none  block rounded-xl border border-gray-900 p-8 shadow-xl transition hover:border-black-500/10 hover:shadow-black-500/10"
            // href="/services/digital-campaigns"
          >
            <h2 className="mt-4 text-xl font-bold text-black">
              Boost enthusiasm
            </h2>

            <p className="mt-1 text-sm text-black">
              Through this lab we aim to foster learning. To enthuse students to
              conduct experiments by the arousing their curiosity. This would
              help them in learning basic and advanced concepts through remote
              experimentation. And help the student try and innovate things.
            </p>
          </p>

          <p
            className="block rounded-xl border border-gray-800 p-8 shadow-xl transition hover:border-pink-500/10 hover:shadow-pink-500/10"
            // href="/services/digital-campaigns"
          >
            <h2 className="mt-4 text-xl font-bold text-black">
              Remote-access to Labs for everyone
            </h2>

            <p className="mt-1 text-sm text-black">
              To provide remote-access to Labs in various disciplines of Science
              and Engineering. These Virtual Labs would cater to students at the
              undergraduate level, post graduate level as well as to research
              scholars (everyone).
            </p>
          </p>

          <p
            className="textDecoration-none  block rounded-xl border border-gray-900 p-8 shadow-xl transition hover:border-black-500/10 hover:shadow-black-500/10"
            // href="/services/digital-campaigns"
          >
            <h2 className="mt-4 text-xl font-bold text-black">
              Complete Learning Management System
            </h2>

            <p className="mt-1 text-sm text-black">
              To provide a complete Learning Management System around the
              Virtual Labs where the students can avail the various tools for
              learning which will help in animated demonstrations and self
              evaluation.
            </p>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Objectives;
